import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IReportCategory } from "@/data/model/ReportCategory";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class ReportCategoryTableController {
    private $element: JQuery;
    private dao: CatalogDao;
    private dataTable: DataTable<IReportCategory>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<CatalogDao>(CatalogDao);

        const tableConfig: IDataTableConfig<IReportCategory> = {
            columnMapping: [
                {
                    name: i18n("general.fields.designation"),
                    property: "name",
                    styles: { width: "35%" },
                },
                {
                    name: i18n("general.fields.internalNote"),
                    property: "internalNote",
                    styles: { width: "45%" },
                },
                {
                    name: i18n("general.fields.sort"),
                    property: "order",
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            locationDependend: true,
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IReportCategory>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.nonVouchersReportCategoryDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/reportcategory/" + m.id;
            },
            (m) => {
                window.open("/reportcategory/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
